module.exports = "/images/icon_comment.svg?594302ec2daacd3b499e6c0d770d9041";